// extracted by mini-css-extract-plugin
module.exports = {"sz6ocgr":"sz6ocgr"};